import React from 'react';
import { capitalize } from 'lodash';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import TimesList from './TimesList';
import OTIcon from '../../tag/OTIcon';
import { formatDate, getTime } from '../../../utils/TimeUtils';

let { id: module_id } = module;

/**
 * Data foramt:
 *
 * data: {
 *    availableTimes: [
 *      day: moment,
 *      closed: boolean,
 *      times: [
 *        {
 *          startDate: moment,
 *          endDate: moment
 *        }
 *      ]
 *    ]
 * }
 */
class DayView extends React.Component {
  constructor() {
    super();
    this.state = {
      open: false,
    };
  }

  componentDidMount() {
    let { data, selectedTime } = this.props;

    if (data && selectedTime) {
      if (selectedTime && selectedTime.dateStart.isSame(data.day, 'day')) {
        this.setState({ open: true });
      }
    }
  }

  render() {
    let { data, selectTime, selectedTime, currentDay } = this.props;
    let { open } = this.state;

    let date = data.day.format('DD.MM.YYYY');
    let isInPast = data.day.startOf('day').isBefore(currentDay.startOf('day'));

    let weekDay = capitalize(data.day.format('dddd'));

    let status = null;
    let times = null;

    let hasAvailableTimes = !(
      !data.availableTimes || data.availableTimes.closed
    );
    if (isInPast) {
      // empty blocks
    } else if (!hasAvailableTimes) {
      times = (
        <div style={{ textAlign: 'center' }}>
          <FormattedMessage id={`${module_id}.no.available.times`} />
        </div>
      );
      status = <FormattedMessage id={`${module_id}.no.available.times`} />;
    } else {
      status = <FormattedMessage id={`${module_id}.has.available.times`} />;
      let _selectedTime = null;
      if (selectedTime && selectedTime.dateStart.isSame(data.day, 'day')) {
        _selectedTime = selectedTime;
      }
      times = (
        <TimesList
          times={data.availableTimes.times.sort((a, b) =>
            a.dateStart.isBefore(b.dateStart) ? -1 : 1
          )}
          selectTime={selectTime}
          selectedTime={_selectedTime}
        />
      );
    }

    return (
      <div className={'dayview-container'}>
        <div
          className={classnames('dayview-datedisplay', {
            'no-times': !isInPast && !hasAvailableTimes,
            'in-past': isInPast,
          })}
        >
          <div>
            <span className={'dayview-weekday'}>{weekDay}</span>
            <span className={'dayview-date'}>{date}</span>
            {hasAvailableTimes && (
              <button
                className={'show-mobile dayview-toggle'}
                onClick={() => {
                  this.setState({ open: !open });
                }}
              >
                <OTIcon
                  config={{
                    type: 'fa',
                    color: 'white',
                    name: open ? 'icon-chevron-up' : 'icon-chevron-down',
                  }}
                />
              </button>
            )}
            <span className={'dayview-status show-mobile'}>{status}</span>
          </div>
        </div>
        <div className={classnames('dayview-times', { closed: !open })}>
          {times}
        </div>
      </div>
    );
  }
}

export default DayView;
